import React from 'react';
import { useSelector } from 'react-redux';
import { getRegion } from '../../../../../../utils/Region';
//-----------------------------------------------------------------
import { MatchDetails } from '../MatchDetails';
import './style.scss';

export const BracketRoundContainer = ({ round, position }) => {
  const translations = useSelector(
    state => JSON.parse(state.metadata.translations).language[getRegion()],
  );

  //Elimina la ronda de tercer puesto
  if (round?.phase.id === 'GN0RDNSRNFX8CN5') return null;

  return (
    <div className={`bracket-round-container  ${round?.phase.names.short} ${position}`}>
      <div className="bracket-round-container__round-title">
        <span>{round?.phase.names.default?.toUpperCase()}</span>
      </div>
      <div
        className={`bracket-round-container__pairs ${round?.phase.names.short} ${round?.phase.names.short} ${position}`}
      >
        {round?.pairs.map((matchInfo, i) => (
          <MatchDetails
            key={`${round?.phase.id}${i}`}
            match={matchInfo?.matches[0]}
            roundId={round?.phase.id}
            translations={translations}
          />
        ))}
      </div>
    </div>
  );
};
